<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.listaguion li{list-style-type: none}
.listaguion li:before{content: "-"; position:relative; left:-5px;}
</style>

<template>
  <div>
    <h2>El sitio de Puebla  en 1863 y la instauración del Segundo Imperio Mexicano</h2>
    <img @click="imageClicked(0)" src="galerias/sala2/S2_G8.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Entrega de las llaves de la Ciudad de México al Gral. Forey</b><br>
      Autor: José María Calderón<br>
      Año: Siglo XIX<br>
      Técnica: Óleo sobre tela<br>
      Medidas: 107 x 184 cm.<br>
      Colección Museo de la Ciudad de México<br>
    </p>
    <br>
    <p>La victoria de la Batalla del 5 de mayo de 1862 fue muy significativa para los mexicanos, sin embargo, el triunfo sólo logró retrasar un año el avance de los invasores ya que, triplicando sus fuerzas militares, se apoderaron de buena parte del país.</p>
    <p>
      “[…] La Francia tiene interés en que los Estados Unidos sean una república próspera y poderosa; mas no en que se apoderen de todo el Golfo de México, que dominen las Antillas y la América del Sur y sean los solos dispensadores de los productos del Nuevo Mundo... […]”
      <ul class="listaguion">
        <li>Fragmento de la carta de Napoleón III a Forey, jefe de las fuerzas intervencionistas en julio de 1862.</li>
      </ul>
    </p>
    <p>El 17 de mayo 1863, Puebla fue ocupada por el ejército francés con el apoyo del grupo conservador mexicano. Juárez abandonó la capital del país y trasladó su gobierno a San Luis Potosí, donde permaneció por algunos meses -del 9 de junio al 22 de diciembre- al año siguiente se instaló en Saltillo.</p>
    <p>La capital del país fue tomada el 10 de junio por el Gral. francés Elías Federico Forey, enviado por Napoleón III, para sustituir al Gral. Lorencez, y establecer las bases de lo que sería el Segundo Imperio Mexicano con Maximiliano de Habsburgo como emperador, de 1863 a 1867.</p>
    <h3>La instauración del Segundo Imperio Mexicano</h3>
    <img @click="imageClicked(1)" src="galerias/sala2/S2_G8_SUB.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Escudo de Maximiliano de Habsburgo</b><br>
      Autor: desconocido<br>
      Año: Siglo XIX<br>
      Técnica: Óleo sobre tela<br>
      Medidas: 54 x 41 cm.<br>
      Colección Museo de Historia Mexicana<br>
    </p>
    <h5>Ver más:</h5>
    <p>Fuente de la imagen:<br><a target="_blank" href="https://www.3museos.com/?pieza=escudo-de-maximiliano-de-habsburgo">www.3museos.com</a></p>
  </div>
</template>

<script>
export default {
  name: "s22g08",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
